// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ad-z","articleImagesWrap":"bd-z","articleImage":"cd-z","singleImage":"dd-z"};